/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoYandexZenIcon24Solid = forwardRef('LogoYandexZenIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.5 2A4.5 4.5 0 0 0 2 6.5v5.2c4.054-.05 6.332-.327 7.852-1.847 1.52-1.52 1.797-3.8 1.848-7.853H6.5Z" }),
        React.createElement("path", { d: "M12.3 2c.05 4.054.327 6.332 1.847 7.853 1.52 1.52 3.799 1.797 7.853 1.847V6.5A4.5 4.5 0 0 0 17.5 2h-5.2Z" }),
        React.createElement("path", { d: "M22 12.3c-4.054.05-6.333.327-7.853 1.847-1.52 1.52-1.797 3.8-1.848 7.853H17.5a4.5 4.5 0 0 0 4.5-4.5v-5.2Z" }),
        React.createElement("path", { d: "M11.7 22c-.05-4.054-.327-6.332-1.848-7.853C8.332 12.627 6.054 12.35 2 12.3v5.2A4.5 4.5 0 0 0 6.5 22h5.2Z" })));
});
